import { Plus } from '@phosphor-icons/react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactGroupType } from 'contacts/enums';
import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { AddContactGroupByEmail } from './AddContactGroupByEmail';

interface IProps {
  contactGroupType: ContactGroupType;
  defaultOpen?: boolean;
}

export const AddContactGroupByEmailButton = ({
  contactGroupType = ContactGroupType.CUSTOMER,
  defaultOpen = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const { t } = useTranslation();

  useEffect(() => {
    if (defaultOpen) {
      setIsOpen(true);
    }
  }, [defaultOpen]);

  const buttonLabel = useMemo(() => {
    return contactGroupType === ContactGroupType.CUSTOMER
      ? t('buttonLabelAddCustomer')
      : t('buttonLabelAddVendor');
  }, [contactGroupType, t]);

  return (
    <>
      <Button
        color={Color.PRIMARY}
        text={buttonLabel}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <AddContactGroupByEmail
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        contactGroupType={contactGroupType}
      />
    </>
  );
};
